export function formatSettlementAmount(row) {
  if (row && row.currencyCode && row.currencyAmount != null) {
    return `${row.currencyAmount} ${row.currencyCode}`
  }

  return '-'
}

export function formatSettlementRate(row) {
  if (!row) return '-'

  const rate = row.currencyRate ?? row.exchangeRateJp ?? row.rate ?? row.exchangeRate
  return rate == null || rate === '' ? '-' : String(rate).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1')
}
